__turbopack_context__.v({
  "container": "UwzunG_container",
  "heading": "UwzunG_heading",
  "headingMain": "UwzunG_headingMain",
  "headingSubtitle": "UwzunG_headingSubtitle",
});
